import { Container, Row, Col} from "react-bootstrap";
import Card from 'react-bootstrap/Card';

export const Projects = () => {
    return (
        <section className="project" id="projects">
            <Container>
                <Row>
                    <Col>
                        <h2>Projects</h2>
                            <p>Welcome to my project showcase! Each of these projects has been a hands-on adventure, teaching me new skills, challenging my problem-solving, and sparking my curiosity for what technology can achieve. From full-stack apps to low-level interpreters, every project here represents a step in my journey to becoming a more creative and capable developer. Dive in to see what I've been building!</p>                        
                        <Row>
                            <Col md={6}>
                                <Card className="card1">
                                    <Card.Body>
                                        <Card.Title>Personal Portfolio!</Card.Title>
                                        <Card.Subtitle className="mb-2">JavaScript, React, NodeJS, HTML/CSS</Card.Subtitle>
                                        <Card.Text>
                                        This portfolio is where I experiment with ReactJS, NodeJS, and JavaScript, to bring my ideas to life and showcase what I've learned. Building this site has been my first solo project, allowing me to create something that reflects my growth as a developer. It's also the first time I've experimented with deployment. It’s a living project, one I’m excited to keep expanding as I grow, learn new technologies, and refine my skills.
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={6}>
                            <Card className="card2">
                                    <Card.Body>
                                        <Card.Title>Splitty</Card.Title>
                                        <Card.Subtitle className="mb-2">Java, JavaFX, SQL, Gradle, Spring Boot, Mockito</Card.Subtitle>
                                        <Card.Text>
                                        Meet Splitty, the app that makes splitting bills and tracking expenses a breeze! As my first full-stack project, it was an exciting deep dive into both front and backend development, where I got hands-on with JavaFX, Spring Boot, RESTful APIs, and database design. Working with an amazing team of five, I led the backend integration, running lots of testing and debugging to make sure it all clicked. This project was a huge learning experience!
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <Card className="card1">
                                <Card.Body>
                                    <Card.Title>Brainfuck Interpreter in x86 Assembly</Card.Title>
                                    <Card.Subtitle className="mb-2">x86 Assembly</Card.Subtitle>
                                    <Card.Text>
                                    Taking on a Brainfuck interpreter in x86 assembly was a real workout for my programming skills. This project pushed me to dig deep into low-level programming, memory management, and debugging. I got to see firsthand how assembly language interacts with the hardware, transforming a minimalistic language into a functional program. It was challenging but super rewarding to see everything come together in such a unique way!
                                    </Card.Text>                                    
                                </Card.Body>
                                </Card>
                            </Col>

                            <Col md={6}>
                                <Card className="card2">
                                <Card.Body>
                                    <Card.Title>Modern Day NPZ Models</Card.Title>
                                    <Card.Subtitle className="mb-2">Python, LaTeX</Card.Subtitle>
                                    <Card.Text>
                                    When math meets marine ecosystems! In this project, I used differential equations and Python’s Euler’s method to simulate the population dynamics of nutrients, phytoplankton, and zooplankton. It was a fascinating dive into how math and programming can work together to capture complex ecological patterns, bringing life to scientific modeling.
                                    </Card.Text>
                                </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                    </Col>
                </Row>
            </Container>
        </section>
    )
}